import React from 'react'

export default function WarningIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="57" height="52" viewBox="0 0 57 52" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.6236 7.1995L53.1532 34.7998C56.9726 41.5995 52.0671 50 44.2637 50H13.2095C5.41125 50 0.500647 41.6046 4.32515 34.8049L19.8548 7.20465C23.7462 0.265975 33.7219 0.265975 37.6236 7.1995Z"
        stroke="#6C7284"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.7395 26.6576V17.3048"
        stroke="#6C7284"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.7344 36.9721C28.477 36.9721 28.2711 37.1832 28.2763 37.4354C28.2763 37.6928 28.4873 37.8987 28.7395 37.8987C28.9917 37.8987 29.1976 37.6876 29.1976 37.4354C29.1976 37.1832 28.9917 36.9721 28.7344 36.9721"
        stroke="#6C7284"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
